
    import * as React from 'react';

    const ChevronUp12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M1.266 8.499l-.532-.53 5.222-5.236 5.307 5.234-.526.534-4.776-4.71z" /></svg>
        </div>
      );
    };

    ChevronUp12.displayName = 'ChevronUp12';

    export default ChevronUp12;
  